import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-stage-warm contour-lines py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22f3erh9dfjom">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yejggad2aa0w">
        <div className="text-center" data-id="element-22" data-mp="1ao7d7csrh1gn">
          <span className="inline-flex items-center gap-2 rounded-md border-2 border-goldDeep bg-gold px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-forestDeep" data-id="element-23" data-mp="1ap8p1jhlprzf">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jh0uffrrqax5" /> Included at no extra cost
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-forestDeep sm:text-4xl" data-id="element-25" data-mp="1eozo0aha7ef1">
            The {totalBonuses} exclusive bonuses
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="mzee57guedht">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-xl border border-line bg-white p-6 shadow-card ${bonus.wide ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="29q0d8wr5007i" data-mpi={index}>
                <div className="flex items-center justify-between gap-4" data-id="element-28" data-mp="1vrilmny423kb">
                  <div className="flex items-center gap-3" data-id="element-29" data-mp="20roci1wk3m1c">
                    <span className="flex h-10 w-10 items-center justify-center rounded-md bg-forest text-goldBright" data-id="element-30" data-mp="20q3jwhtsyd64">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="25o54x8asgmk8" />
                    </span>
                    <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-earth" data-id="element-32" data-mp="3c8whaob47461">
                      Bonus {bonus.number}
                    </p>
                  </div>
                  <p className="text-xs font-bold text-inkSoft" data-id="element-33" data-mp="1h5i08vfv26kx">
                    <span className="line-through" data-id="element-34" data-mp="1c3iuxg0k8zlc">Real value {bonus.value}</span>
                    <span className="ml-2 rounded-md bg-gold px-2 py-1 text-[11px] font-extrabold uppercase tracking-wide text-forestDeep" data-id="element-35" data-mp="1q4d80byjzoqc">
                      Free
                    </span>
                  </p>
                </div>

                <h3 className="mt-4 text-lg font-extrabold leading-tight text-forestDeep" data-id="element-36" data-mp="yd5mzdno5kw0">{bonus.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-inkSoft" data-id="element-37" data-mp="tbq3vr51xog9">{bonus.description}</p>

                <p className="mt-4 rounded-lg border-l-4 border-forestMid bg-beige px-4 py-3 text-sm font-semibold text-ink" data-id="element-38" data-mp="177bx6aibiueh">
                  {bonus.benefit}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl border-2 border-forest bg-forest px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-39" data-mp="ao4ke71ip3yn">
          <div data-id="element-40" data-mp="59uuphy77ff7">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-goldBright" data-id="element-41" data-mp="5amnkl0euz1s">
              Value of all {totalBonuses} bonuses
            </p>
            <p className="mt-1 font-display text-2xl font-extrabold text-cream line-through decoration-gold decoration-2" data-id="element-42" data-mp="3morv32zitabt">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-43" data-mp="janou1kl88hs">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-goldBright" data-id="element-44" data-mp="o9ik42zqrpis">Your price today</p>
            <p className="mt-1 font-display text-3xl font-extrabold text-cream" data-id="element-45" data-mp="9chovpicdcfk">FREE</p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-earth" data-id="element-46" data-mp="e9hww5yr4p9b">
          Only included in this offer
        </p>
      </div>
    </section>;
}